<template>
  <!--
    DsTextarea — entrada multi-línea del DS (elements/textarea/textarea.css).
    Hereda el lenguaje del input; difiere en height variable, padding simétrico,
    resize vertical, line-height 1.5. v-model estándar.
  -->
  <textarea
    class="ds-textarea"
    :class="{ 'is-error': error, 'ds-textarea--wide': wide, 'ds-textarea--fixed': fixed }"
    :value="modelValue"
    :rows="rows"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :aria-invalid="error ? 'true' : undefined"
    v-bind="$attrs"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'DsTextarea',
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    rows: { type: [Number, String], default: 3 },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    wide: { type: Boolean, default: true },
    /** sin handle de resize. */
    fixed: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped lang="scss">
.ds-textarea {
  font-family: var(--font-sans);
  font-size: var(--text-body-s-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--text-default);
  background: var(--surface-elevated);
  display: block;
  width: auto;
  min-height: calc(40px + var(--space-4));
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  transition:
    border-color var(--duration-base, 240ms) var(--ease-default, ease),
    background var(--duration-base, 240ms) var(--ease-default, ease),
    box-shadow var(--duration-base, 240ms) var(--ease-default, ease);
}
.ds-textarea--wide { width: 100%; }
.ds-textarea--fixed { resize: none; }
.ds-textarea::placeholder { color: var(--text-muted); opacity: 1; }
@media (pointer: coarse) { .ds-textarea { font-size: 16px; } }

@media (hover: hover) and (pointer: fine) {
  .ds-textarea:hover:not([disabled]):not([readonly]) { border-color: var(--text-muted); }
}
.ds-textarea:focus-visible {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent);
}
.ds-textarea.is-error,
.ds-textarea[aria-invalid="true"] { border-color: var(--border-error); }
.ds-textarea.is-error:focus-visible,
.ds-textarea[aria-invalid="true"]:focus-visible {
  border-color: var(--border-error);
  box-shadow: 0 0 0 1px var(--border-error);
}
.ds-textarea[disabled] {
  background: var(--surface-disabled);
  color: var(--text-disabled);
  border-color: var(--border-disabled);
  cursor: not-allowed;
  pointer-events: none;
  resize: none;
}
.ds-textarea[readonly] {
  background: var(--surface-disabled);
  border-color: var(--border-control);
  cursor: default;
  resize: none;
}
.ds-textarea[readonly]:focus-visible {
  border-color: var(--border-control);
  box-shadow: 0 0 0 1px var(--border-control);
}
</style>
